// GuestReservationDetails.js
import React from 'react';
import { Box, Grid, TextField, InputAdornment } from '@mui/material';
import CustomTypography from '../../../components/UIComponents/CustomTypography';
import theme from '../../../assets/theme';
const inputBoxStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: theme.borderRadius.medium,
    backgroundColor: theme.palette.lightgray.main,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    "& fieldset": {
      borderColor: theme.palette.gray.main,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused": {
      backgroundColor: theme.palette.light.main,
      "& fieldset": {
        borderColor: theme.palette.primary.main,
      }
    }
  }
};

const StyledTextField = ({ label, placeholder, InputProps, ...props }) => (
  <Box>
    {label && (
      <CustomTypography variant="bodyText1" display="block" gutterBottom color="textSecondary">
        {label}
      </CustomTypography>
    )}
    <TextField
      size="small"
      fullWidth
      placeholder={placeholder}
      sx={inputBoxStyle}
      InputProps={InputProps}
      {...props}
    />
  </Box>
);

const GuestReservationDetails = ({ details }) => (
  <Box
    sx={{
      backgroundColor: theme.palette.light.main,
      borderRadius: 2,
      boxShadow: '0px 4px 12px rgba(74, 76, 78, 0.25)',
      p: 3,
      mt: 2,
    }}
  >
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <CustomTypography
        variant="SubTitleBold"
        display="block"
        gutterBottom
        color="dark.main"
      >
        Guest & Reservation Details
      </CustomTypography>

      {/* <Box
        display="flex"
        alignItems="center"
        gap={2}
        px={2}
        border="2px solid #27394D"
        borderRadius="8px"
      >
        <CustomTypography
          variant="buttonL"
          display="block"
          gutterBottom
          color="textSecondary"
          mt={1}
        >
          To Be Invoiced:
        </CustomTypography>

        <CustomTypography
          variant="HeadingLarge"
          display="block"
          gutterBottom
          color="textSecondary"
          mt={0.5}
        >
          ₹ NA
        </CustomTypography>
      </Box> */}
    </Box>

    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={2.5}>
        <StyledTextField label="Guest Name" disabled value={details?.primary_guest_name} placeholder="Guest Name" />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <StyledTextField label="Mobile" disabled value={details?.primary_guest_mobile} />
      </Grid>
      <Grid item xs={12} sm={6} md={1.6}>
        <StyledTextField label="E-mail" disabled value={details?.primary_guest_email} />
      </Grid>
      <Grid item xs={12} sm={6} md={1.6}>
        <StyledTextField label="Room No." value={details?.room} disabled />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <StyledTextField label="Room Type" value={details?.room_type} disabled />
      </Grid>
      <Grid item xs={12} sm={6} md={2.2}>
        <StyledTextField label="Rate / Package" value={details?.package ?? "NA"} disabled />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <StyledTextField label="From Date" value={details?.from_date} disabled />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <StyledTextField label="To Date" value={details?.to_date} disabled />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <StyledTextField label="No. of Nights" value={details?.no_of_days} disabled />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <StyledTextField
          label="Reservation Type"
          value={`${details?.reservation_type ?? "Individual"}`}
          disabled
        // InputProps={{
        //   startAdornment: <InputAdornment position="start">₹</InputAdornment>,
        // }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={1.5}>
        <StyledTextField label="Adult/Child" value={`${details?.no_of_adult} / ${details?.no_of_child}`} disabled />
      </Grid>
      <Grid item xs={12} sm={6} md={2.5}>
        <StyledTextField label="Company" disabled value={details?.corporate} />
      </Grid>
    </Grid>

    {/* <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
      <Box />
      <Box display="flex" gap={1} alignItems="center">
        <CustomTypography variant="subHeading">Total Room Charge :</CustomTypography>
        <CustomTypography
          variant="subHeading"
          color="dark.main"
          sx={{
            backgroundColor: theme.palette.lightgray.main,
            borderRadius: theme.borderRadius.medium,
            p: 1,
            width: '250px',
            textAlign: 'right',
            border: '1px solid var(--Gray, #CFCFCF)',
          }}
        >
          ₹ NA
        </CustomTypography>
      </Box>
    </Box> */}
  </Box>
);

export default GuestReservationDetails;
